import { useEffect, useState } from "react";
import closeIcon from "../../../assets/image/close.png";
import {
  useAddQuizMutation,
  useEditQuizMutation,
  useGetQuizQuery,
} from "../../../features/quizzes/quizzesApi";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import Error from "../../ui/Error";

export default function QuizzesModal({ open, control, task, quizId }) {
  const [checkQuizId, setCheckQuizId] = useState(false);
  const { data: quiz } =
    useGetQuizQuery(quizId, {
      skip: !checkQuizId,
    }) || {};

  let initialOptionOne = undefined;
  let initialOptionTwo = undefined;
  let initialOptionThree = undefined;
  let initialOptionFour = undefined;
  let initialIsCorrectOne = undefined;
  let initialIsCorrectTwo = undefined;
  let initialIsCorrectThree = undefined;
  let initialIsCorrectFour = undefined;

  const {
    question: initialQuestion,
    video_id: initialVideoId,
    video_title: initialVideoTitle,
    options,
    id,
  } = quiz || "";

  if (quiz) {
    initialOptionOne = options[0]?.option;
    initialOptionTwo = options[1]?.option;
    initialOptionThree = options[2]?.option;
    initialOptionFour = options[3]?.option;
    initialIsCorrectOne = options[0]?.isCorrect;
    initialIsCorrectTwo = options[1]?.isCorrect;
    initialIsCorrectThree = options[2]?.isCorrect;
    initialIsCorrectFour = options[3]?.isCorrect;
  }

  useEffect(() => {
    if (quizId !== undefined) {
      setCheckQuizId(true);
    }
  }, [quizId]);

  useEffect(() => {
    setQuestion(initialQuestion);
    setVideoId(initialVideoId);
    setVideoTitle(initialVideoTitle);
    setOptionOne(initialOptionOne);
    setOptionTwo(initialOptionTwo);
    setOptionThree(initialOptionThree);
    setOptionFour(initialOptionFour);
    setIsCorrectOne(initialIsCorrectOne);
    setIsCorrectTwo(initialIsCorrectTwo);
    setIsCorrectThree(initialIsCorrectThree);
    setIsCorrectFour(initialIsCorrectFour);
  }, [
    initialQuestion,
    initialOptionOne,
    initialOptionTwo,
    initialOptionThree,
    initialOptionFour,
    initialVideoId,
    initialVideoTitle,
    initialIsCorrectOne,
    initialIsCorrectTwo,
    initialIsCorrectThree,
    initialIsCorrectFour,
  ]);

  const [question, setQuestion] = useState(initialQuestion || "");
  const [videoId, setVideoId] = useState(initialVideoId || "");
  const [videoTitle, setVideoTitle] = useState(initialVideoTitle || "");
  const [optionOne, setOptionOne] = useState(initialOptionOne || "");
  const [optionTwo, setOptionTwo] = useState(initialOptionTwo || "");
  const [optionThree, setOptionThree] = useState(initialOptionThree || "");
  const [optionFour, setOptionFour] = useState(initialOptionFour || "");
  const [isCorrectOne, setIsCorrectOne] = useState(initialIsCorrectOne || "");
  const [isCorrectTwo, setIsCorrectTwo] = useState(initialIsCorrectTwo || "");
  const [isCorrectThree, setIsCorrectThree] = useState(
    initialIsCorrectThree || ""
  );
  const [isCorrectFour, setIsCorrectFour] = useState(
    initialIsCorrectFour || ""
  );

  const [addQuiz, { isLoading, isSuccess, isError, error }] =
    useAddQuizMutation();

  const { data: videos } = useGetVideosQuery() || {};

  const [
    editQuiz,
    {
      isLoading: editLoading,
      isSuccess: editIsSuccess,
      isError: editIsError,
      error: editError,
    },
  ] = useEditQuizMutation();

  useEffect(() => {
    if (isSuccess || editIsSuccess) {
      control();
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (task === "Add") {
      addQuiz({
        data: {
          question,
          video_id: videoId,
          video_title: videoTitle,
          options: [
            {
              id: 1,
              option: optionOne,
              isCorrect: isCorrectOne === undefined ? false : isCorrectOne,
            },
            {
              id: 2,
              option: optionTwo,
              isCorrect: isCorrectTwo === undefined ? false : isCorrectTwo,
            },
            {
              id: 3,
              option: optionThree,
              isCorrect: isCorrectThree === undefined ? false : isCorrectThree,
            },
            {
              id: 4,
              option: optionFour,
              isCorrect: isCorrectFour === undefined ? false : isCorrectFour,
            },
          ],
        },
      });
    } else if (task === "Edit") {
      editQuiz({
        id,
        data: {
          question,
          video_id: videoId,
          video_title: videoTitle,
          options: [
            {
              id: 1,
              option: optionOne,
              isCorrect: isCorrectOne,
            },
            {
              id: 2,
              option: optionTwo,
              isCorrect: isCorrectTwo,
            },
            {
              id: 3,
              option: optionThree,
              isCorrect: isCorrectThree,
            },
            {
              id: 4,
              option: optionFour,
              isCorrect: isCorrectFour,
            },
          ],
        },
      });
    }
  };

  const handleVideo = (e) => {
    setVideoId(e.target.value);
    setVideoTitle(e.target.selectedOptions[0].text);
  };

  return (
    open && (
      <>
        <div
          onClick={control}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="rounded w-[400px] lg:w-[600px] space-y-8 text-white bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <button
            className="absolute close-icon bg-transparent text-white font-bold text-xl focus:outline-none"
            onClick={control}
          >
            <img src={closeIcon} alt="Close Icon" />
          </button>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            {task} Quiz
          </h2>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="question" className="sr-only">
                  Question
                </label>
                <input
                  id="question"
                  name="question"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Quiz question"
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                />
              </div>
              <div>
                <label
                  htmlFor="video-title"
                  className="sr-only block text-gray-700 font-bold mb-2"
                >
                  Quiz for Video
                </label>
                <select
                  id="video-title"
                  name="video-title"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  value={videoId}
                  onChange={(e) => handleVideo(e)}
                >
                  <option value="" className="placeholder-gray-500">
                    Select Video for Quiz
                  </option>
                  {videos?.map((video) => {
                    if (video.id === videoId) {
                      return (
                        <option key={video.id} value={video.id} selected>
                          {video.title}
                        </option>
                      );
                    } else {
                      return (
                        <option key={video.id} value={video.id}>
                          {video.title}
                        </option>
                      );
                    }
                  })}
                </select>
              </div>
              <div>
                <label htmlFor="option1" className="sr-only">
                  Option One
                </label>
                <input
                  id="option1"
                  name="option1"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Option one..."
                  value={optionOne}
                  onChange={(e) => setOptionOne(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="option2" className="sr-only">
                  Option Two
                </label>
                <input
                  id="option2"
                  name="option2"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Option two..."
                  value={optionTwo}
                  onChange={(e) => setOptionTwo(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="option3" className="sr-only">
                  Option Three
                </label>
                <input
                  id="option3"
                  name="option3"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Option three..."
                  value={optionThree}
                  onChange={(e) => setOptionThree(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="option4" className="sr-only">
                  Option Four
                </label>
                <input
                  id="option4"
                  name="option4"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Option four..."
                  value={optionFour}
                  onChange={(e) => setOptionFour(e.target.value)}
                />
              </div>
              <div className="flex items-center">
                <p className="mx-auto">Select correct option:</p>
                <div className="flex items-center mx-auto">
                  <input
                    id="option1"
                    name="option"
                    type="checkbox"
                    className="mr-2"
                    checked={isCorrectOne}
                    onChange={(e) => setIsCorrectOne(e.target.checked)}
                  />
                  <label htmlFor="option1">Option 1</label>
                </div>
                <div className="flex items-center mx-auto">
                  <input
                    id="option2"
                    name="option"
                    type="checkbox"
                    className="mr-2"
                    checked={isCorrectTwo}
                    onChange={(e) => setIsCorrectTwo(e.target.checked)}
                  />
                  <label htmlFor="option2">Option 2</label>
                </div>
                <div className="flex items-center mx-auto">
                  <input
                    id="option3"
                    name="option"
                    type="checkbox"
                    className="mr-2"
                    checked={isCorrectThree}
                    onChange={(e) => setIsCorrectThree(e.target.checked)}
                  />
                  <label htmlFor="option3">Option 3</label>
                </div>
                <div className="flex items-center mx-auto">
                  <input
                    id="option4"
                    name="option"
                    type="checkbox"
                    className="mr-2"
                    checked={isCorrectFour}
                    onChange={(e) => setIsCorrectFour(e.target.checked)}
                  />
                  <label htmlFor="option4">Option 4</label>
                </div>
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                disabled={isLoading || editLoading}
              >
                {task === "Add" ? "Add" : "Edit"} Quiz
              </button>
            </div>

            {isError && <Error message={error?.data} />}
            {editIsError && <Error message={editError?.data} />}
          </form>
        </div>
      </>
    )
  );
}
